import { render, staticRenderFns } from "./arrange-porperty.vue?vue&type=template&id=516156c0&scoped=true&"
import script from "./arrange-porperty.vue?vue&type=script&lang=js&"
export * from "./arrange-porperty.vue?vue&type=script&lang=js&"
import style0 from "./arrange-porperty.vue?vue&type=style&index=0&id=516156c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516156c0",
  null
  
)

export default component.exports